import { useState, useEffect } from "react";
import { decodeJwtPayload } from "@/utils/product";
import { logger } from "@/utils/logger";

/**
 * Custom hook to extract customer-related data from JWT token
 */
export const useCustomer = () => {
  const [customer, setCustomer] = useState({
    customerId: null,
    stripeCustomerId: null,
    email: null,
    phone: null,
    accessType: null,
    rawPayload: null,
  });

  useEffect(() => {
    const extractCustomerData = () => {
      try {
        const token =
          sessionStorage.getItem("authToken") ||
          localStorage.getItem("authToken");

        if (!token) {
          logger.warn("No auth token found");
          return;
        }

        const payload = decodeJwtPayload(token);

        if (!payload) {
          logger.warn("Failed to decode JWT payload");
          return;
        }
        setCustomer({
          customerId: payload.customerId ?? null,
          stripeCustomerId: payload.stripeCustomerId ?? null,
          email: payload.email ?? null,
          phone: payload.phone ?? null,
          accessType: payload.accessType ?? null,
          rawPayload: payload,
        });
      } catch (error) {
        logger.error("Error extracting customer data from token:", error);
        setCustomer({
          customerId: null,
          stripeCustomerId: null,
          email: null,
          phone: null,
          accessType: null,
          rawPayload: null,
        });
      }
    };

    // Initial extraction
    extractCustomerData();

    // Listen for storage changes (when token is updated)
    const handleStorageChange = (e) => {
      if (e.key === "authToken" || e.key === null) {
        extractCustomerData();
      }
    };

    // Listen for custom event when token is updated in same tab
    const handleTokenUpdate = () => {
      extractCustomerData();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("authTokenUpdated", handleTokenUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("authTokenUpdated", handleTokenUpdate);
    };
  }, []);

  return customer;
};
